import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Creators as TaskCreators } from 'store/ducks/task';
import { Spinner } from 'triider-components';
import moment from 'moment';
import chatIcon from 'assets/img/icons/chat.svg';
import {
  Container, CommentForm, CommentInput, SendButton,
  WrapperComments, ContentComments, UserComment, ContainerComment, TypeActivity,
} from './styles';


function CommentsTab({
  taskId, comments, userId, loadingGetComments, _includeComment,
}) {
  const [commentField, setCommentField] = useState('');
  const [withFocus, setWithFocus] = useState(false);
  const textRef = useRef();

  const onSubmit = (e) => {
    e.preventDefault();
    _includeComment({ taskId, comment: { type: 'comment', user_id: userId, description: commentField } });
    setCommentField('');
    textRef.current.style.height = '16px';
  };

  const handleChangeComment = (e) => {
    const { target } = e;
    textRef.current.style.height = '16px';
    textRef.current.style.height = `${target.scrollHeight}px`;
    setCommentField(e.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      onSubmit(event);
    }
  };

  return (
    <Container>
      <CommentForm onSubmit={onSubmit} withFocus={withFocus}>
        <CommentInput
          onFocus={() => setWithFocus(true)}
          onBlur={() => setWithFocus(false)}
          placeholder="Escreva um comentário"
          name="comment"
          heightForm={16}
          onKeyPress={handleKeyPress}
          ref={textRef}
          value={commentField}
          onChange={handleChangeComment}
        />
        <SendButton disabled={!commentField} type="submit">
          Enviar
        </SendButton>
      </CommentForm>

      <WrapperComments>
        {loadingGetComments ? <Spinner size="larger" />
          : comments.map((comment) => {
            if (!comment.is_visible_company) {
              return '';
            }
            return (
              <ContainerComment key={comment.id}>
                <UserComment>
                  <img src={comment.user_image || `https://ui-avatars.com/api/?background=FF7700&color=fff&name=${comment.user_name && comment.user_name.replace(' ', '%20')}`} alt="Imagem do usuário" />
                  <h4>{comment.user_name}</h4>
                  <span>
                    {moment(comment.created_at).format('DD/MM/YY')}
                    {' '}
                    ás
                    {' '}
                    {moment(comment.created_at).format('HH:mm:ss')}
                  </span>
                </UserComment>
                <ContentComments isComment={comment.type === 'comment'}>
                  <TypeActivity>
                    {comment.type === 'comment'
                      && <img src={chatIcon} alt="ícone do chat" />
                    }
                  </TypeActivity>
                  <p>{comment.description}</p>
                </ContentComments>
              </ContainerComment>
            );
          })
        }
      </WrapperComments>
    </Container>
  );
}

const mapStateToProps = state => ({
  comments: state.task.comments,
  taskId: state.task.taskDetail.id,
  loadingGetComments: state.ui.loaders.includes('GET_COMMENTS_REQUEST'),
  userId: state.auth.triiderUser.user.id,
});

const mapDispatchToProps = {
  _includeComment: TaskCreators.includeCommentRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsTab);
